// eslint-disable
import React, { memo, useEffect } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
// import { reactSelectCustomStyle } from "helper";
import Region from './Region';
import Province from './Province';
import Municipality from './Municipality';
import Barangay from './Barangay';

const tmp_region_code = '130000000';
const tmp_province_code = '133900000';

const regionReadOnly = true;
const provinceReadOnly = true;
const municipalityReadOnly = true;

const Address = memo(
  ({
    name,
    region_name,
    province_name,
    municipality_name,
    barangay_name,
    street_name,
    onChange,
    value,
    readOnly,
    label,
    withBarangay,
    withStreet,
    children,
    validatorMessage,
    removeLabel,
    type,
    regionDisabled,
    provinceDisabled,
    municipalityDisabled,
  }) => {
    const handleOnchange = (target, data, zipCode) => {
      if (target === 'region') {
        onChange({
          target: {
            name,
            value: {
              region_code: data,
              province_code: '',
              municipality_code: '',
              barangay_code: '',
              street: _.get(value, 'street', ''),
            },
          },
        });
      }

      if (target === 'province') {
        onChange({
          target: {
            name,
            value: {
              region_code: _.get(value, 'region_code'),
              province_code: data,
              municipality_code: '',
              barangay_code: '',
              zip_code: '',
              street: _.get(value, 'street', ''),
            },
          },
        });
      }

      if (target === 'municipality') {
        onChange({
          target: {
            name,
            value: {
              region_code: _.get(value, 'region_code'),
              province_code: _.get(value, 'province_code'),
              municipality_code: data,
              barangay_code: '',
              street: _.get(value, 'street', ''),
            },
          },
        });
      }

      if (target === 'barangay') {
        onChange({
          target: {
            name,
            value: {
              region_code: _.get(value, 'region_code'),
              province_code: _.get(value, 'province_code'),
              municipality_code: _.get(value, 'municipality_code'),
              barangay_code: data,
              zip_code: zipCode,
              street: _.get(value, 'street', ''),
            },
          },
        });
      }

      if (target === 'street') {
        onChange({
          target: {
            name,
            value: {
              region_code: _.get(value, 'region_code'),
              province_code: _.get(value, 'province_code'),
              municipality_code: _.get(value, 'municipality_code'),
              barangay_code: _.get(value, 'barangay_code'),
              street: data,
            },
          },
        });
      }
    };

    const onChangeRegion = (data) => {
      handleOnchange(
        'region',
        data ? _.get(data, 'fullInfo.attributes.code') : ''
      );
    };

    const onChangeProvince = (data) => {
      handleOnchange(
        'province',
        data ? _.get(data, 'fullInfo.attributes.code') : ''
      );
    };

    const onChangeMunicipality = (data) => {
      handleOnchange(
        'municipality',
        data ? _.get(data, 'fullInfo.attributes.code') : ''
      );
    };

    const onChangeBarangay = (data) => {
      handleOnchange(
        'barangay',
        data ? _.get(data, 'fullInfo.attributes.code') : '',
        _.get(data, 'fullInfo.attributes.zip_code', '')
      );
    };

    const onChangeStreet = (e) => {
      handleOnchange('street', e.target.value);
    };

    useEffect(() => {
      onChange({
        target: {
          name,
          value: {
            region_code: _.get(value, 'region_code') || tmp_region_code,
            province_code: _.get(value, 'province_code') || tmp_province_code,
            municipality_code: _.get(value, 'municipality_code') || '',
            barangay_code: _.get(value, 'barangay_code') || '',
            district: _.get(value, 'district') || '',
            zone: _.get(value, 'zone') || '',
            street: _.get(value, 'street'),
          },
        },
      });
    }, []);

    return (
      <>
        <div className="full-group ">
          {removeLabel === false && (
            <label
              htmlFor="business_address"
              className="form-label d-flex align-items-center text-success"
            >
              {label || `Address`}
            </label>
          )}
          <div className="row">
            <div className="form-input-group  col-12 col-md-6 ">
              <label className="form-label d-flex align-items-center">
                Region {validatorMessage(region_name)}
              </label>
              <Region
                name={name}
                readOnly={type === 'Business' ? regionReadOnly : readOnly}
                // styles={reactSelectCustomStyle}
                value={_.get(value, 'region_code')}
                onChange={onChangeRegion}
                isDisabled={regionDisabled}
              />
            </div>
            <div className="form-input-group  col-12 col-md-6 ">
              <label className="form-label d-flex align-items-center">
                Province {validatorMessage(province_name)}
              </label>
              <Province
                name={name}
                readOnly={type === 'Business' ? provinceReadOnly : readOnly}
                // styles={reactSelectCustomStyle}
                value={_.get(value, 'province_code')}
                regionCode={_.get(value, 'region_code')}
                onChange={onChangeProvince}
                isDisabled={provinceDisabled}
              />
            </div>
            <div className="form-input-group col-12 col-md-6 mt-2">
              <label className="form-label d-flex align-items-center">
                City/Municipality {validatorMessage(municipality_name)}
              </label>
              <Municipality
                name={name}
                readOnly={type === 'Business' ? municipalityReadOnly : readOnly}
                // styles={reactSelectCustomStyle}
                value={_.get(value, 'municipality_code')}
                regionCode={_.get(value, 'region_code')}
                provinceCode={_.get(value, 'province_code')}
                onChange={onChangeMunicipality}
                isDisabled={municipalityDisabled}
              />
            </div>
            {withBarangay && (
              <div className="form-input-group col-12 col-md-6 mt-2">
                <label className="form-label d-flex align-items-center">
                  Barangay {validatorMessage(barangay_name)}
                </label>
                <Barangay
                  name={name}
                  readOnly={readOnly}
                  // styles={reactSelectCustomStyle}
                  value={_.get(value, 'barangay_code')}
                  regionCode={_.get(value, 'region_code')}
                  provinceCode={_.get(value, 'province_code')}
                  municipalityCode={_.get(value, 'municipality_code')}
                  onChange={onChangeBarangay}
                />
              </div>
            )}
            {children}
          </div>
        </div>
        {withStreet && (
          <div className="full-group ">
            <div className="form-row">
              <div className="form-input-group col-12 ">
                <label className="form-label d-flex align-items-center">
                  Unit/Room number/Floor, Building Name, House number, Street
                  name. {validatorMessage(street_name)}
                </label>
                {readOnly && (
                  <span className="full-input text-uppercase">
                    {_.get(value, 'street')}
                  </span>
                )}
                {!readOnly && (
                  <input
                    placeholder="_"
                    readOnly={readOnly}
                    type="input"
                    onChange={onChangeStreet}
                    value={_.get(value, 'street')}
                    className="form-control text-uppercase"
                  />
                )}
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
);

Address.defaultProps = {
  name: undefined,
  region_name: undefined,
  province_name: undefined,
  municipality_name: undefined,
  barangay_name: undefined,
  street_name: undefined,
  readOnly: undefined,
  label: undefined,
  withBarangay: true,
  withStreet: true,
  children: undefined,
  validatorMessage: () => {},
  removeLabel: false,
  type: '',
  regionDisabled: true,
  provinceDisabled: true,
  municipalityDisabled: true,
};

Address.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string,
  region_name: PropTypes.string,
  province_name: PropTypes.string,
  municipality_name: PropTypes.string,
  barangay_name: PropTypes.string,
  street_name: PropTypes.string,
  readOnly: PropTypes.bool,
  onChange: PropTypes.instanceOf(Function).isRequired,
  value: PropTypes.exact({
    region_code: PropTypes.string,
    province_code: PropTypes.string,
    municipality_code: PropTypes.string,
    barangay_code: PropTypes.string,
    street: PropTypes.string,
  }).isRequired,
  withBarangay: PropTypes.bool,
  withStreet: PropTypes.bool,
  children: PropTypes.node,
  validatorMessage: PropTypes.instanceOf(Function),
  removeLabel: PropTypes.bool,
  type: PropTypes.string,
  regionDisabled: PropTypes.bool,
  provinceDisabled: PropTypes.bool,
  municipalityDisabled: PropTypes.bool,
};

export default Address;
